import styles from "../../../views/ReportView/ReportView.module.css";
import Swal from "sweetalert2";
import axios from "axios";

const BajaButtonCompany = ({ company, setCompany }) => {
  const handleBaja = async () => {
    const id = company.cuit;
    try {
      const res = await axios.post(process.env.REACT_APP_CASUALTY_COMPANY_API, {
        id,
        newStatus: "Baja",
      });

      if (res.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Correcto",
          text: "La Persona Jurídica se dio de baja correctamente",
        });
        setCompany({
          ...company,
          status: "Baja",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: error.message,
      });
    }
  };

  return (
    <button type="button" onClick={handleBaja} className={styles.altabaja}>
      Dar de Baja
    </button>
  );
};

export default BajaButtonCompany;